import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AddchartIcon from '@mui/icons-material/Addchart';
import moment from "moment";

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GroupIcon from '@mui/icons-material/Group';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import TaskIcon from '@mui/icons-material/Task';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Popover from '@mui/material/Popover';
import { TableColumn } from 'react-data-table-component';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import HowToRegIcon from '@mui/icons-material/HowToReg';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import PaymentsIcon from '@mui/icons-material/Payments';
import Grid from '@mui/material/Grid2';
import './Dashboard.css';
import PieChart from '../../Components/PieChart/PieChart';
import DataGrid from '../../Components/DataGrid/DataGrid';
import ProfileServices from '../../Services/ProfileServices';
import { loadFromLocalStorage, saveToLocalStorage } from '../../Common/Validation/LocalStorage';
import BigButton from '../../Components/BigButton';
import DashboardServices from '../../Services/DashboardServices';
import { amountFormat } from '../../Components/helper';
import { Avatar, Box, FormControl, MenuItem, Select, Typography } from '@mui/material';


interface IDashboard {
  accessToken: string;
  dashboardFilter: ["Day", "Month", "Year", "Custom"],
  popOverTargetElement: any,
  selectedAccount: string,
  filteredDate: {
    startDate: Date,
    endDate: Date
  },
  selectedDateRange: {
    startDate: Date,
    endDate: Date
  },
  selectedFilterIndex: number,
  filterDateString: string,
  cards: ICard[],
  formValues: IFormTable[],
  chartData: {
    labels: any,
    datasets: any,
  },
  tenantIndex: number

}

interface ICard {
  title: string,
  value: string,
  note: string
}

interface IFormTable {
  formType: string,
  submitted: string,
  approved: string,
  rejected: string
}

class Dashboard extends React.Component<{}, IDashboard> {
  private calendarInputElm = React.createRef<HTMLElement>();

  constructor(props: any) {
    super(props);
    this.state = {
      popOverTargetElement: null,
      accessToken: '',
      dashboardFilter: ["Day", "Month", "Year", "Custom"],
      selectedAccount: "1", // Default account type is Resolution (on page load)
      filteredDate: {
        startDate: new Date(),
        endDate: new Date()
      },
      selectedDateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      selectedFilterIndex: 0,
      filterDateString: `${moment(new Date()).format('MM-DD-YYYY')}`,
      cards: [{
        title: '',
        note: '',
        value: '0'
      }],
      formValues: [],
      chartData: {
        labels: [],
        datasets: [],
      },
      tenantIndex: 1
    };
  }

  handleChange = (event: any) => {
    this.setState({
      selectedAccount: event.target.value
    }, () => {
      this.getDashboardDetails();

    });
  };

  private options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  async componentDidMount() {
    const accesstoken = await loadFromLocalStorage('accessToken');

    if (accesstoken) {
      this.setState({
        accessToken: accesstoken.toString()
      }, () => {
        this.getUserDetails(accesstoken.toString());
      })

    }
    else {
      localStorage.clear();
      window.location.href = '/'
    }

    const tenantData = JSON.parse(localStorage.getItem('TENANT_CONFIG') || '{}');
    this.setState({
      tenantIndex: tenantData?.tenant_index
    });
  }

  private formColumns: TableColumn<any>[] = [
    {
      name: 'Form Type',
      id: 'FormType',
      selector: (row: any) => row.formType,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Submitted',
      id: 'Submitted',
      selector: (row: any) => row.submitted,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Approved',
      id: 'Approved',
      selector: (row: any) => row.approved,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Rejected',
      id: 'Rejected',
      selector: (row: any) => row.rejected,
      style: { whiteSpace: 'nowrap' }
    }
  ];

  private kwongFormColumns: TableColumn<any>[] = [
    {
      name: 'Form Type',
      id: 'FormType',
      selector: (row: any) => row.formType,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Signed',
      id: 'Signed',
      selector: (row: any) => row.signed,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'UnSigned',
      id: 'UnSigned',
      selector: (row: any) => row.unSigned,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Submitted',
      id: 'Submitted',
      selector: (row: any) => row.submitted,
      style: { whiteSpace: 'nowrap' }
    },
    {
      name: 'Approved',
      id: 'Approved',
      selector: (row: any) => row.approved,
      style: { whiteSpace: 'nowrap' }

    },
    {
      name: 'Rejected',
      id: 'Rejected',
      selector: (row: any) => row.rejected,
      style: { whiteSpace: 'nowrap' }

    }
  ];

  private pickIconComponent(title: string) {
    try {
      switch (title) {
        case 'Total Revenue':
          return <AddchartIcon className='dash-cardContHeadIcon' />;
        case 'Total Subscriptions':
          return <PersonAddAlt1Icon className='dash-cardContHeadIcon' />;
        case 'Total Users':
          return <GroupIcon className='dash-cardContHeadIcon' />;
        case 'Forms Submitted':
          return <UploadFileIcon className='dash-cardContHeadIcon' />;
        case 'Forms Approved':
          return <TaskIcon className='dash-cardContHeadIcon' />;
        case 'Registered Users':
          return <HowToRegIcon className='dash-cardContHeadIcon' />;
        case 'Identity Verification':
          return <FingerprintIcon className='dash-cardContHeadIcon' />;
        case 'Sign Authorization':
          return <NoteAltIcon className='dash-cardContHeadIcon' />;
        case 'One time fee Payment':
          return <PaymentsIcon className='dash-cardContHeadIcon' />;
      }
    }
    catch (ex) {

    }

  }

  private getUserDetails(accessToken: string) {
    ProfileServices.getUserDetails(accessToken).then(r => {
      if (r.ok) {
        this.getDashboardDetails();
      }
    });
  }

  private onFilterDate(item: number) {
    if (item === 3) {
      this.calendarInputElm.current?.click();

    }
    else {
      let date = moment(new Date()).format('MM-DD-YYYY');
      let filteredDate = this.state.filteredDate;
      switch (item) {
        case 0:
          date = `${moment(new Date()).format('MM-DD-YYYY')}`;
          filteredDate = {
            startDate: new Date(),
            endDate: new Date()
          };
          break;
        case 1:
          filteredDate = {
            startDate: moment(new Date()).startOf('month').toDate(),
            endDate: moment(new Date()).endOf('month').toDate()
          };
          // &#8212;
          date = `${moment(new Date()).startOf('month').format('MM-DD-YYYY')} to ${moment(new Date()).endOf('month').format('MM-DD-YYYY')}`;
          break;
        case 2:
          filteredDate = {
            startDate: moment(new Date()).startOf('year').toDate(),
            endDate: moment(new Date()).endOf('year').toDate()
          };
          date = `${moment(new Date()).startOf('year').format('MM-DD-YYYY')} to ${moment(new Date()).endOf('year').format('MM-DD-YYYY')}`;
          break;
      }

      this.setState({
        selectedFilterIndex: item,
        filterDateString: date,
        filteredDate: filteredDate
      }, () => {
        this.getDashboardDetails();
      });
    }
  }

  private navDate(nav: string) {
    let dateRange = this.state.filteredDate;
    let navType = nav == "prev" ? -1 : 1;

    // Day
    if (this.state.selectedFilterIndex == 0) {
      dateRange.startDate = moment(dateRange.startDate).add(navType, "days").toDate();
      dateRange.endDate = moment(dateRange.endDate).add(navType, "days").toDate();
    }
    // Month
    else if (this.state.selectedFilterIndex == 1) {
      dateRange.startDate = moment(dateRange.startDate).add(navType, "months").startOf('month').toDate();
      dateRange.endDate = moment(dateRange.endDate).add(navType, "months").endOf('month').toDate();
    }
    else if (this.state.selectedFilterIndex == 2) {
      dateRange.startDate = moment(dateRange.startDate).add(navType, "years").toDate();
      dateRange.endDate = moment(dateRange.endDate).add(navType, "years").toDate();
    }
    else if (this.state.selectedFilterIndex == 3) {
      let date1 = moment(dateRange.startDate);
      let date2 = moment(dateRange.endDate);
      let diff = Math.abs(date1.diff(date2, 'days')) + 1;

      dateRange.startDate = moment(dateRange.startDate).add((diff) * navType, "days").toDate();
      dateRange.endDate = moment(dateRange.endDate).add((diff) * navType, "days").toDate();
    }

    let dateString = `${moment(dateRange.startDate).format('MM-DD-YYYY')} to ${moment(dateRange.endDate).format('MM-DD-YYYY')}`;

    if (this.state.selectedFilterIndex == 0) {
      dateString = `${moment(dateRange.startDate).format('MM-DD-YYYY')}`;
    }

    this.setState({
      filterDateString: dateString,
      filteredDate: dateRange
    }, () => {
      this.getDashboardDetails()
    });
  }

  private handleSelectDate(ranges: any) {
    let dateRange = this.state.filteredDate;
    dateRange.startDate = ranges.range1.startDate;
    dateRange.endDate = ranges.range1.endDate;

    this.setState({
      selectedDateRange: dateRange
    })
  }

  private applyDateRange() {
    let dateRange = this.state.selectedDateRange;

    let date = `${moment(dateRange.startDate).format('MM-DD-YYYY')} to ${moment(dateRange.endDate).format('MM-DD-YYYY')}`;
    this.setState({
      filteredDate: dateRange,
      filterDateString: date,
      selectedFilterIndex: 3,
      popOverTargetElement: null
    }, () => {
      this.getDashboardDetails();
    });
  }

  render() {
    return (

      <div className='body-sub-contianer'>
        <div className='dashboard-filter'>
          <h1>Dashboard</h1>
          <div className='filtered-item'>
          </div>
          <FormControl size="small" sx={{ minWidth: 220, mr: 1 }}>
            <Select value={(this.state.tenantIndex === 2) ? '2' : this.state.selectedAccount} disabled={this.state.tenantIndex === 2} onChange={this.handleChange}
              sx={{
                borderRadius: 3,
                backgroundColor: '#fff',
                fontWeight: 500,
                boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                '& .MuiSelect-select': {
                  padding: '10px 14px',
                },
                '& fieldset': {
                  borderColor: '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--secondary-main)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--secondary-main)',
                  borderWidth: '1px',
                },
              }}
            >
              <MenuItem value="1">Resolution</MenuItem>
              <MenuItem value="2">Kwong</MenuItem>
            </Select>
          </FormControl>
          <div className='filtered-option'>
            {
              this.state.dashboardFilter.map((item, index) => {
                return (<div key={index}
                  className={'filter-item ' + (this.state.selectedFilterIndex == index ? 'selected' : '')}
                  onClick={() => {
                    this.onFilterDate(index);
                  }}>{item}</div>);
              })
            }
            <div className='filtered-tags'>
              <NavigateBeforeIcon className='nav-btn'
                onClick={() => {
                  this.navDate('prev');
                }}
                fontSize='medium' />
              <span ref={this.calendarInputElm} onClick={(ev_) => {
                this.setState({
                  popOverTargetElement: ev_.target as HTMLElement
                });
              }}>{this.state.filterDateString}</span>
              <NavigateNextIcon
                className='nav-btn'
                fontSize='medium'
                onClick={() => {
                  this.navDate('next');
                }}
              /></div>
          </div>
          <Popover
            id={'simple-popover'}
            open={this.state.popOverTargetElement != null}
            anchorEl={this.state.popOverTargetElement}
            onClose={() => {
              this.setState({
                popOverTargetElement: null
              });
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <div className='popover-calendar'>
              <DateRangePicker
                ranges={[this.state.filteredDate]}
                onChange={(ranges: any) => {
                  console.log(ranges);
                  this.handleSelectDate(ranges);
                }}
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DateRangeCalendar', 'DateRangeCalendar']}>
                  <DemoItem>
                    <DateRangeCalendar
                    sx={{
                      '& .css-tzi8uf-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected': {
                        color: '#fff !important',
                        backgroundColor: 'rgb(86, 123, 149) !important',
                        fontWeight: 500,
                      },
                      '.css-1xga70z-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected' :{
                        color: '#fff !important',
                        backgroundColor: 'rgb(86, 123, 149) !important',
                        fontWeight: 500,
                      },
                      '.css-i7zndj-MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected': {
                        color: '#fff !important',
                        backgroundColor: 'rgb(86, 123, 149) !important',
                        fontWeight: 500,
                      }
                    }}
                      value={[dayjs(this.state.filteredDate.startDate), dayjs(this.state.filteredDate.endDate)]}
                      onChange={(newValue) => this.handleSelectDate(newValue)}
                    />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider> */}

              <BigButton
                disabled={false}
                width='80%'
                onClick={() => {
                  this.applyDateRange();
                }} buttonText="Apply" />
            </div>
          </Popover>
        </div >
        <div className='cards'>
          <Grid container spacing={3} sx={{ mt: 1, p: 3, backgroundColor: '#f5f7fa', alignItems: 'flex-start' }}>
            {this.state.cards.map((eachItem: any, index) => {
              return (
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                  <Card
                    sx={{
                      borderRadius: 4,
                      boxShadow: 3,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0px 3px 30px 10px var(--secondary-main)',
                      },
                      '&:hover .note': {
                        maxHeight: 200,
                      },
                    }}
                  >
                    <CardContent className='card-content'>
                      {/* Top Row: Icon + Title */}
                      <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <Box
                          sx={{
                            backgroundColor: 'var(--secondary-main)',
                            borderRadius: '50%',
                            padding: '6px',
                            display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                          }}
                        >
                          <Avatar
                            sx={{
                              backgroundColor: 'var(--primary-main)',
                              width: 24,
                              height: 24,
                              padding: '22px'
                            }}
                          >
                            {this.pickIconComponent(eachItem.title)}
                          </Avatar>
                        </Box>

                        <Typography fontWeight="bold" fontSize={16} sx={{ color: 'var(--primary-main)', mb: 0 }}>
                          {eachItem.title}
                        </Typography>
                      </Box>

                      {/* Highlighted Value */}
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ color: 'var(--primary-main)', mb: 1 }}
                      >
                        {eachItem.title === 'Total Revenue' ? amountFormat(eachItem.value, 'en-US', 'USD') : eachItem.value}
                      </Typography>
                      {/* Note with clamp */}
                      <Typography
                        className="note"
                        variant="body2"
                        sx={{
                          color: 'text.secondary',
                          overflow: 'hidden',
                          maxHeight: 40,
                          transition: 'max-height 0.4s ease',
                        }}
                      >
                        {eachItem.note}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>)
            })}
          </Grid>
        </div>
        <div className='cards' >
          <Card style={{ width: '70%', display: 'flex', margin: '10px', borderRadius: '10px' }}>
            <CardContent style={{ width: '100%', color: 'var(--primary-main)' }} >
              {/* <div className='dash-cardContentHeader'>

                <h2 className='dash-ml-10'>Users chart</h2>
              </div> */}
              <DataGrid
                title='Form Details' columns={this.state.selectedAccount == "1" ? this.formColumns : this.kwongFormColumns} data={this.state.formValues} style={{ color: 'red !important' }} />
            </CardContent>
          </Card>
          <Card style={{ width: '25%', display: 'flex', margin: '10px', borderRadius: '10px' }}>
            <CardContent className='dash-cardContent'>
              <div className='dash-cardContentHeader'>
                <h2 className='dash-ml-10'>Users chart</h2>
              </div>
              <PieChart data={this.state.chartData} options={this.options}></PieChart>
            </CardContent>
          </Card>
        </div>
      </div >
    );
  }

  getDashboardDetails() {

    let dateRange = this.state.filteredDate;
    let postData = {
      startDate: `${moment(dateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')}`,
      endDate: `${moment(dateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')}`
    };

    DashboardServices.getDashboardDetails({ filteredDate: postData }, this.state.accessToken, this.state.selectedAccount).then((r: any) => {
      if (r.ok) {
        r.json().then((resp: any) => {
          const isEmpty = resp["userCountDetails"]["verified"] == 0 && resp["userCountDetails"]["deactivated"] && resp["userCountDetails"]["un_verified"] == 0

          const chartData = isEmpty
            ? {
              labels: ["No Data"],
              datasets: [
                {
                  data: [1], // Placeholder data
                  backgroundColor: ["#d3d3d3"], // Grey for no data
                  borderColor: ["#b0b0b0"],
                },
              ],
            }
            : {
              labels: ["Active", "Inactive", "Unverified"],
              datasets: [
                {
                  data: [resp["userCountDetails"]["verified"], resp["userCountDetails"]["deactivated"], resp["userCountDetails"]["un_verified"]],
                  backgroundColor: ['rgba(108, 230, 38, 0.5)',
                    'rgba(54, 162, 235, 0.5)',
                    'rgba(247, 217, 141, 0.5)',],
                  borderColor: [
                    'rgba(172, 250, 109, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)'],
                },
              ],
            };

          this.setState({ cards: resp['cards'], formValues: resp['formDetails'], chartData: chartData }, () => {
            console.log(this.state);
          });
        });
      }

    });
  }
}

export default Dashboard;